(function ( ) {
    ///
    const tabs = document.querySelectorAll('.mbr-options-tabs .mbr-options-tab');
    const cards = document.querySelectorAll('.mbr-options .card');

    tabs.forEach(function(tab) {
        tab.addEventListener('click', function(event) {
            event.preventDefault();

            if (!tab.classList.contains('active')) {
                const index = Array.prototype.indexOf.call(tabs, tab);
                const current = document.querySelectorAll('.mbr-options .active');

                document.querySelector('.mbr-options-tabs .active').setAttribute('aria-expanded', 'false');
                current.forEach(function(el) {
                    el.classList.remove('active');
                });
                tab.classList.add('active');
                tab.setAttribute('aria-expanded', 'true');
                cards[index].classList.add('active');
            }
        });
    });
    ///
}( ));
